import { ROTATE_SPEED_MS } from './controls.js';

const VR_KMH = Math.round(ROTATE_SPEED_MS * 3.6); // 操作ヘルプに出す Vr (km/h)

const ARROWS = ['↑', '↗', '→', '↘', '↓', '↙', '←', '↖'];
// 機首基準の相対方位(rad, 0=正面,+右回り) を 8 方向の矢印に変換。
function bearingArrow(rad) {
  if (!Number.isFinite(rad)) return ''; // NaN は typeof で 'number' を通すので除外
  let a = rad % (2 * Math.PI);
  if (a < 0) a += 2 * Math.PI;
  const idx = Math.round(a / (Math.PI / 4)) % 8;
  return ARROWS[idx];
}

export function createHud({ name }) {
  const speedEl = document.getElementById('hud-speed');
  const altEl = document.getElementById('hud-alt');
  const hdgEl = document.getElementById('hud-heading');
  const aglEl = document.getElementById('hud-agl');
  const airportEl = document.getElementById('hud-airport');
  const siteEl = document.getElementById('hud-site');
  const siteProgressEl = document.getElementById('hud-site-progress');
  const cityEl = document.getElementById('hud-city');
  const toastEl = document.getElementById('game-toast');
  const bannerEl = document.getElementById('landing-banner');
  const helpEl = document.getElementById('controls-help');

  if (cityEl) cityEl.textContent = name ?? '-';

  let toastTimer = 0;
  let bannerTimer = 0;

  return {
    // 今飛んでいる都市名（cityTracker の逆ジオコーディング結果、変化時のみ届く）。
    // 初期値は上でセット済みの出発都市名のまま、最初の結果が来たら置き換わる。
    setCity(city) {
      if (cityEl) cityEl.textContent = city;
    },
    setControlMode(mode) {
      if (!helpEl) return;
      if (mode === 'mobile') {
        helpEl.innerHTML =
          `<strong>操作:</strong> 左下スティックで操縦 / 右下 +/− で加減速 / 右上 👁 で視点切替 / 離陸: ＋長押しで加速→Vr(≈${VR_KMH}km/h)でスティック上 / Esc: 都市選択 / <strong>光る輪をくぐると世界史の解説</strong>`;
      } else {
        helpEl.innerHTML =
          `<strong>操作:</strong> ← →: 旋回 / ↑ ↓: 機首上げ下げ / Shift: 加速 / Ctrl: 減速 / B: ブレーキ / V: 視点切替 / R: 機体向き / M: 消音 / 離陸: Shift長押し→Vr(≈${VR_KMH}km/h)で↑ / Esc: 都市選択 / <strong>光る輪をくぐると世界史の解説</strong>`;
      }
    },
    // 世界史スポットの訪問数。変化したときだけ game.js から呼ぶ。
    setSiteProgress(visited, total) {
      if (siteProgressEl) siteProgressEl.textContent = `${visited}/${total}`;
    },
    update({ speedMs, altitudeM, headingRad, aglM, airport, site }) {
      speedEl.textContent = (speedMs * 3.6).toFixed(0);
      altEl.textContent = Math.max(0, altitudeM).toFixed(0);
      let deg = (headingRad * 180) / Math.PI;
      if (deg < 0) deg += 360;
      if (deg >= 360) deg -= 360;
      hdgEl.textContent = deg.toFixed(0);
      if (aglEl && typeof aglM === 'number') {
        aglEl.textContent = Math.max(0, aglM).toFixed(0);
      }
      if (airportEl) {
        airportEl.classList.toggle('approaching', !!airport?.approaching);
        if (!airport) {
          airportEl.textContent = '-';
        } else if (airport.approaching) {
          airportEl.textContent = `${airport.name} に接近中`;
        } else {
          const km = (airport.distanceM / 1000).toFixed(1);
          airportEl.textContent = `${bearingArrow(airport.relBearingRad)} ${airport.name} ${km}km`;
        }
      }
      // 最寄りの世界史スポット。書式は空港行とまったく同じ（矢印＋名前＋距離）。
      if (siteEl) {
        siteEl.classList.toggle('visited', !!site?.visited);
        if (!site) {
          siteEl.textContent = '-';
        } else {
          const km = (site.distanceM / 1000).toFixed(1);
          siteEl.textContent =
            `${bearingArrow(site.relBearingRad)} ${site.name} ${km}km${site.visited ? ' ✓' : ''}`;
        }
      }
    },
    // 着陸結果の大きな中央バナー（variant: 'success' | 'warn' | 'fail'）。
    showLanding(message, variant = 'success', durationMs = 3500) {
      if (!bannerEl) return;
      bannerEl.textContent = message;
      bannerEl.className = '';
      bannerEl.classList.add(variant);
      bannerEl.hidden = false;
      // 連続発火でも pop アニメが再生されるよう一旦リセットして reflow。
      bannerEl.style.animation = 'none';
      void bannerEl.offsetWidth;
      bannerEl.style.animation = '';
      clearTimeout(bannerTimer);
      bannerTimer = setTimeout(() => { bannerEl.hidden = true; }, durationMs);
    },
    showToast(message, durationMs = 4000) {
      if (!toastEl) return;
      toastEl.textContent = message;
      toastEl.hidden = false;
      clearTimeout(toastTimer);
      toastTimer = setTimeout(() => {
        toastEl.hidden = true;
      }, durationMs);
    },
    dispose() {
      clearTimeout(toastTimer);
      clearTimeout(bannerTimer);
      if (toastEl) toastEl.hidden = true;
      if (bannerEl) bannerEl.hidden = true;
    },
  };
}
